function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1Km(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 63.0690346,
    cy: 43.1349487,
    r: 31.6561317
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7471D"
    },
    d: "M63.3258705,128.0243378c-0.3694305,0-0.6688614-0.2994308-0.6688614-0.6688614V95.615654 c0-0.3694458,0.2994308-0.6688766,0.6688614-0.6688766c0.3694458,0,0.6688766,0.2994308,0.6688766,0.6688766v31.7398224 C63.9947472,127.7249069,63.6953163,128.0243378,63.3258705,128.0243378z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF3333"
    },
    d: "M63.3258858,2.1098449c-22.6665611,0-41.0416794,18.3751087-41.0416794,41.0416565 c0,40.5280037,41.0416794,64.9416351,41.0416794,64.9416351s41.0416679-23.1508331,41.0416679-64.9416351 C104.3675537,20.4849529,85.9924316,2.1098449,63.3258858,2.1098449z M63.3258858,73.7615433 c-16.8741837,0-30.5511742-13.6769905-30.5511742-30.5511742s13.6769905-30.5511589,30.5511742-30.5511589 s30.5511436,13.6769896,30.5511436,30.5511589S80.200058,73.7615433,63.3258858,73.7615433z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.4133492,
    y: 32.9253616,
    style: {
      fill: "none"
    },
    width: 53.4317627,
    height: 25.9413338
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 39.6522217 47.5656128)",
    style: {
      fill: "#FF3333",
      fontFamily: "'OpenSans-Bold'",
      fontSize: "19.2633667px"
    }
  }, "1 KM")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Km);
export default __webpack_public_path__ + "static/media/1km.487cb65b78e5ecbaf1c6e9b7e808b645.svg";
export { ForwardRef as ReactComponent };